export default {
  'menu.welcome': '欢迎',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.prompt': '提示词管理',
  'menu.prompt.page': '书页管理',
  'menu.prompt.doll': '玩偶管理',
  'menu.prompt.character-card': '角色卡管理',
  'menu.prompt.free-dialogue': '无书页自由对话',
  'menu.prompt.prompt-word': 'AI分析-提示词',
  'menu.user-management': '用户管理',
  'menu.user-management.mini-program-user': '小程序用户',
  'menu.user-management.user-feedback': '用户反馈',
  'menu.device-management': '设备管理',
  'menu.device-management.list': '设备管理',
  'menu.device-management.binding-record': '绑定记录',
  'menu.device-management.device-data': '设备数据',
  'menu.flow-package': '流量包管理',
  'menu.flow-package.package-list': '套餐管理',
  'menu.flow-package.order-list': '订单管理',
  'menu.log-management': '日志管理',
  'menu.log-management.message-log': '消息日志',
  'menu.system': '系统管理',
  'menu.system.dict': '字典管理',
  'menu.system.notice': '系统通知',
  'menu.system.help-center': '帮助中心',
  'menu.system.privacy-agreement': '配置中心',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
};
